module.exports = {
    Class: require("./Class"),
    abstractMethod: require("./abstractMethod")
};